module.exports = __webpack_public_path__ + "static/media/bg.7163fe76.svg";